import { OnboardingFlowV1 } from 'dashboard/models/onboarding-flow-v1';
import Action from 'lib/interfaces/Action';

export type OnboardingFlowActions =
  | Action<OnboardingFlowActionType.SaveOnboardingFlow, SaveOnboardingFlowPayload>
  | Action<OnboardingFlowActionType.ClearOnboardingFlow>;

export enum OnboardingFlowActionType {
  SaveOnboardingFlow = 'onboarding-flow/SAVE_ONBOARDING_FLOW',
  ClearOnboardingFlow = 'onboarding-flow/CLEAR_ONBOARDING_FLOW',
}

interface SaveOnboardingFlowPayload {
  onboardingFlow?: OnboardingFlowV1;
}

export function saveOnboardingFlow(onboardingFlow: OnboardingFlowV1): OnboardingFlowActions {
  return {
    payload: {
      onboardingFlow,
    },
    type: OnboardingFlowActionType.SaveOnboardingFlow,
  };
}

export function clearOnboardingFlow(): Action<OnboardingFlowActionType.ClearOnboardingFlow> {
  return { type: OnboardingFlowActionType.ClearOnboardingFlow };
}
